import {getHostname} from '@infra/domain/model/Site/getHostname';
import {getBaseRedirectUrl} from '@modules/payments';
import {emitPaymentTrackingEvent} from '@domain/model/Event/domain/model/PayEvent';
import {ScrollView} from '@components/layouts/layout/components/scrollView/ScrollView';
import {ConfigurationApplication} from '@application/Config';
import {setPaymentsBridge, Tradename} from '@lookiero/payments-front';
import packageJson from '../../../../package.json';
import {Platform} from 'react-native';
import {getLocale} from '@helpers';
import {getAuth} from '@infra/api/authManager/authManager';

const configurePayments = (): void => {
  const configuration = ConfigurationApplication.retrieve();
  const host = getHostname();
  const hostUrl = getBaseRedirectUrl();
  const locale = getLocale();

  setPaymentsBridge({
    getToken: getAuth as () => Promise<string>,
    stripeKey: configuration.stripeKey,
    stripeUkKey: configuration.stripeUKKey,
    commonAssetsPath: configuration.commonAssetsPath,
    paymentsAssetsPath: configuration.paymentAssetsPath,
    useAvoidKeyboard: () => ({setAvoidKeyboard: () => void 0}), // TODO remove this in package
    emitTrackingEvent: emitPaymentTrackingEvent,
    appVersion: packageJson.version,
    graphqlUri: `${Platform.OS !== 'web' ? host : ''}/graphql`,
    locale: () => locale,
    scrollView: ScrollView,
    host,
    hostUrl,
    tradename: configuration.tradename as unknown as Tradename,
    factoringSnippetId: configuration.factoringSnippetId || '',
  });
};

export {configurePayments};
